import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import toast from "react-hot-toast";

import { REACT_APP_BACKEND_URL_TEST, CurrentVersion } from "../../config";
import { logout } from "../slices/AuthSlice";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: REACT_APP_BACKEND_URL_TEST,
  prepareHeaders: (headers, { getState }) => {
    const token = getState()?.auth?.token;
    const lang = localStorage.getItem("i18nextLng") || "en";

    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    if (lang) {
      headers.set("Accept-Language", lang);
    }
    if (CurrentVersion) {
      headers.set("current-version", CurrentVersion);
    }
    headers.set("Accept", "application/json");

    return headers;
  },
});

const baseQueryWithInterceptor = async (args, api, extraOptions) => {
  try {
    const result = await rawBaseQuery(args, api, extraOptions);

  if (result?.error) {
    const status = result.error?.status;
    const data = result.error?.data;

    if (status === 401) {
      api.dispatch(logout());
    } else if (!extraOptions?.skipErrorToast) {
      const errMsg =
        data?.details ||
        data?.message ||
        data?.error ||
        result.error?.error ||
        "Request failed";
      if (typeof errMsg === "string") {
        toast.error(errMsg);
      }
    }
  }

    return result;
  } catch (err) {
    const errMsg = err?.message || "Failed to fetch"; 
    
    if (!extraOptions?.skipErrorToast && typeof errMsg === "string") {
      toast.error(errMsg);
    }
    return {
      error: {
        status: "FETCH_ERROR",
        error: errMsg,
      },
    };
  }
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithInterceptor,
  tagTypes: [],
  keepUnusedDataFor: 10,
  endpoints: () => ({}),
});
